import {
  ButtonPrimary,
  ButtonSecondary,
  ClickOutsideDetector,
  IconDown,
  IconSelected,
  IconUp,
  PermissionEnum,
} from '@ui/src';
import isEqual from 'lodash.isequal';
import { generatePath, NavLink } from 'react-router-dom';
import {
  NewApplicationStatus,
  NewApplicationStepStatus,
  ReviewStatus,
} from '../../types';
import { NewApplicationInfoTopControlsTypes } from '../types';

import ROUTES from '../../../../routes';

import cn from '../styles.module.css';

const NewApplicationInfoTopControls = ({
  newApplicationInfo,
  title,
  applicationId,
  isEditable,
  requestInProgress,
  onSubmit,
  fields,
  defaultFormValues,
  questionnarieFields,
  defaultQuestionnarieFormValues,
  accountsCurrenciesValues,
  accountsCurrencies,
  accountsFlowsValues,
  accountsFlows,
  crsAndFatcaValues,
  crsAndFatca,
  expectedFundsOriginsValues,
  expectedFundsOrigins,
  affilatedCompaniesValues,
  affilatedCompanies,
  totalIncomeError,
  percentageError,
  setActionMenuVisibile,
  actionMenuVisible,
  backToIncompleteInProgress,
  submitIsLoading,
  udpateInProgress,
  udpateCofInProgress,
  udpateCorporateInProgress,
  updateCofQuestionnarieInProgress,
  updateIndividualQuestionnarieInProgress,
  updateCorporateQuestionnarieInProgress,
  stepOneBlockLoadingInProgress,
  activePermissions,
  onSubmitApplicationAction,
  setRejectNotifyPopupVisible,
  setPopupVisible,
  onBackToIncomplete,
  submitError,
  globalError,
  questionnarieGlobalError,
  isCorporate,
  isCompanyOfficial,
  stepsStatus,
  createAvailable,
  createInProgress,
  onCreate,
  setResponsiblePopupVisible,
  setWithStatusChange,
  canSelectResponsible,
  infoDictionariesIsLoading,
}: NewApplicationInfoTopControlsTypes) => {
  let createCustomerButtonDisabled: boolean;
  let createAppliсationButtonDisabled = false;

  if (!isCorporate) {
    createCustomerButtonDisabled = Boolean(
      stepsStatus?.stepOne !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepTwo !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepThree !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepFour !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepFive !== NewApplicationStepStatus.COMPLETED,
    );

    if (isCompanyOfficial) {
      createCustomerButtonDisabled = Boolean(
        stepsStatus?.stepOne !== NewApplicationStepStatus.COMPLETED ||
        stepsStatus?.stepTwo !== NewApplicationStepStatus.COMPLETED ||
        stepsStatus?.stepThree !== NewApplicationStepStatus.COMPLETED ||
        stepsStatus?.stepFour !== NewApplicationStepStatus.COMPLETED,
      );
    }
  } else {
    createCustomerButtonDisabled = Boolean(
      stepsStatus?.stepOne !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepTwo !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepThree !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepFour !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepFive !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepSix !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepSeven !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepEight !== NewApplicationStepStatus.COMPLETED,
    );

    createAppliсationButtonDisabled = Boolean(
      stepsStatus?.stepOne !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepTwo !== NewApplicationStepStatus.COMPLETED ||
      stepsStatus?.stepThree !== NewApplicationStepStatus.COMPLETED,
    );
  }

  return (
    <div className={cn.newApplcationTopControls}>
      <div className={cn.newApplicationName}>{title}</div>
      <div className={cn.newApplicationTopRight}>
        {newApplicationInfo?.status !== NewApplicationStatus.DECLINED &&
          newApplicationInfo?.status !== NewApplicationStatus.ACCEPTED && (
            <>
              {applicationId && isEditable && (
                <ButtonSecondary
                  className={`button-white ${cn.saveChangesButton} ${cn.applicationTopButton}`}
                  text={requestInProgress ? 'Loading...' : 'Save changes'}
                  onClick={onSubmit}
                  disabled={
                    (Boolean(isEqual(fields, defaultFormValues)) &&
                      Boolean(
                        isEqual(
                          questionnarieFields,
                          defaultQuestionnarieFormValues,
                        ),
                      ) &&
                      Boolean(
                        isEqual(
                          accountsCurrenciesValues || [],
                          accountsCurrencies || [],
                        ),
                      ) &&
                      Boolean(
                        isEqual(accountsFlowsValues || [], accountsFlows || []),
                      ) &&
                      Boolean(
                        isEqual(crsAndFatcaValues || [], crsAndFatca || []),
                      ) &&
                      Boolean(
                        isEqual(
                          expectedFundsOriginsValues || [],
                          expectedFundsOrigins || [],
                        ),
                      ) &&
                      Boolean(
                        isEqual(
                          affilatedCompaniesValues || [],
                          affilatedCompanies || [],
                        ),
                      )) ||
                    Boolean(totalIncomeError) ||
                    percentageError ||
                    infoDictionariesIsLoading
                  }
                  bold
                />
              )}
              <div className={cn.applicationActionsWrapper}>
                <ClickOutsideDetector
                  setOptionsListVisible={setActionMenuVisibile}
                >
                  <>
                    <button
                      type="button"
                      className={`${cn.applicationActionButton} ${
                        actionMenuVisible ? cn.active : ''
                      }`}
                      onClick={() => setActionMenuVisibile(!actionMenuVisible)}
                      disabled={
                        backToIncompleteInProgress ||
                        submitIsLoading ||
                        udpateInProgress ||
                        udpateCofInProgress ||
                        udpateCorporateInProgress ||
                        updateCofQuestionnarieInProgress ||
                        updateIndividualQuestionnarieInProgress ||
                        updateCorporateQuestionnarieInProgress ||
                        stepOneBlockLoadingInProgress ||
                        infoDictionariesIsLoading
                      }
                    >
                      {backToIncompleteInProgress ||
                      submitIsLoading ||
                      udpateInProgress ||
                      udpateCofInProgress ||
                      udpateCorporateInProgress ||
                      updateCofQuestionnarieInProgress ||
                      updateIndividualQuestionnarieInProgress ||
                      updateCorporateQuestionnarieInProgress ||
                      stepOneBlockLoadingInProgress
                        ? 'Loading...'
                        : 'Select action'}
                      {actionMenuVisible ? (
                        <IconUp width={13} height={13} />
                      ) : (
                        <IconDown
                          width={13}
                          height={13}
                          className={cn.iconDown}
                        />
                      )}
                    </button>
                    {actionMenuVisible && (
                      <div className={cn.actionMenu}>
                        {applicationId && isEditable && (
                          <>
                            {newApplicationInfo?.status ===
                              NewApplicationStatus.INCOMPLETE &&
                              activePermissions?.includes(
                                PermissionEnum.APPLICATIONS_CUSTOMERS_SUBMIT_ACTION,
                              ) && (
                                <button
                                  type="button"
                                  className={cn.actionMenuButton}
                                  onClick={() => {
                                    setActionMenuVisibile(false);
                                    onSubmitApplicationAction();
                                  }}
                                >
                                  Submit application
                                </button>
                              )}
                            <button
                              type="button"
                              className={cn.actionMenuButton}
                              onClick={() => {
                                if (
                                  !newApplicationInfo?.comments?.edges?.map(
                                    (item) => item?.node,
                                  )?.length
                                ) {
                                  setRejectNotifyPopupVisible(true);
                                } else {
                                  setPopupVisible(true);
                                }

                                setActionMenuVisibile(false);
                              }}
                            >
                              Reject application
                            </button>
                            {(newApplicationInfo?.status ===
                              NewApplicationStatus.READY_TO_REVIEW ||
                              newApplicationInfo?.status ===
                                NewApplicationStatus.REVIEW_IN_PROGRESS) && (
                              <button
                                type="button"
                                className={cn.actionMenuButton}
                                onClick={() => {
                                  onBackToIncomplete();

                                  setActionMenuVisibile(false);
                                }}
                              >
                                Back to “Incomplete” status
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </>
                </ClickOutsideDetector>
              </div>
              <div className={cn.submitError}>
                {submitError && <div>{submitError}</div>}
                {globalError && <div>{globalError}</div>}
                {questionnarieGlobalError && (
                  <div>{questionnarieGlobalError}</div>
                )}
              </div>

              {!applicationId && (
                <ButtonPrimary
                  className={`${cn.createButton} ${cn.applicationTopButton}`}
                  text="Create Application"
                  icon={<IconSelected />}
                  onClick={onSubmit}
                  disabled={createAppliсationButtonDisabled}
                  bold
                />
              )}
              {newApplicationInfo?.reviewStatus !==
                ReviewStatus.HAS_DUPLICATE &&
                newApplicationInfo?.status ===
                  NewApplicationStatus.REVIEW_IN_PROGRESS &&
                createAvailable &&
                applicationId && (
                  <ButtonPrimary
                    className={cn.createButton}
                    text={createInProgress ? 'Loading...' : 'Create customer'}
                    icon={<IconSelected />}
                    onClick={onCreate}
                    disabled={
                      createCustomerButtonDisabled || infoDictionariesIsLoading
                    }
                    bold
                  />
                )}
              {newApplicationInfo?.status ===
                NewApplicationStatus.READY_TO_REVIEW && (
                <ButtonPrimary
                  text="Start review"
                  onClick={() => {
                    setResponsiblePopupVisible(true);
                    setWithStatusChange(true);
                  }}
                  disabled={!canSelectResponsible}
                  bold
                />
              )}
            </>
          )}
        {newApplicationInfo?.status === NewApplicationStatus.ACCEPTED &&
          newApplicationInfo?.organizationId && (
            <NavLink
              className={cn.customerLink}
              to={
                isCorporate
                  ? generatePath(ROUTES.CUSTOMERS_CORPORATE_PAGE, {
                      customerId: newApplicationInfo?.organizationId,
                    })
                  : generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_PAGE, {
                      customerId: newApplicationInfo?.organizationId,
                    })
              }
              target="_blank"
            >
              Go to Сustomer
            </NavLink>
          )}
      </div>
    </div>
  );
};

export default NewApplicationInfoTopControls;
